import { BaseResponseHttp } from './commons.model';
import { BooleanCons, HttpStatus, NumberCons, StringConst } from '../../constants/const';

export class IProductsRes extends BaseResponseHttp {
  response?: IProducts[];
}
export class DetailProductRes extends BaseResponseHttp {
  response?: DetailProduct[];
}
export interface FavoriteChangeResponse extends BaseResponseHttp {
  response: FavoriteChange[];
}
export class FavoriteChange {
  cardCode: string;
  container: string;
  isFavorite: boolean;
  itemCode: string;
  label: string;
  constructor() {
    this.cardCode = StringConst.empty;
    this.container = StringConst.empty;
    this.isFavorite = BooleanCons.false;
    this.itemCode = StringConst.empty;
    this.label = StringConst.empty;
  }
}

export class PromotionBanner {
  banners: Promotion[];
  constructor() {
    this.banners = [];
  }
}
export class PromotionRes extends BaseResponseHttp {
  response = new PromotionsData();
}

export class PromotionsData {
  promotions: PromotionBanner[] = [];
  pendingPromotions = 0;
}

export enum PromotionBannerType {
  horizontal = 'horizontal',
  vertical = 'vertical',
  default = ''
}

export class UtilitiesCalculator {
  costPerPiece: number;
  costThePublic: number;
  utilityPercentage: number;
  utility: number;
  newUtilityAmount: number;
  oldUtilityAmount: number;
  quantity: number;
  itemCode: string;
  description: string;
  constructor() {
    this.costPerPiece = NumberCons.zero;
    this.costThePublic = NumberCons.zero;
    this.utilityPercentage = NumberCons.zero;
    this.utility = NumberCons.zero;
    this.newUtilityAmount = NumberCons.zero;
    this.oldUtilityAmount = NumberCons.zero;
    this.quantity = NumberCons.zero;
    this.itemCode = StringConst.empty;
    this.description = StringConst.empty;
  }
}

export interface IProductsDermaRes extends BaseResponseHttp {
  response: IProductsDerma[];
}
export interface IAutoCompleteRes extends BaseResponseHttp {
  response: string[];
}
export interface IProductsDerma {
  padecimientoToShow?: string;
  padecimiento: string;
  products: IProducts[];
}

export enum TypePromotion {
  news = 'news',
  discount = 'discount',
  promotion = 'promotion'
}

export class Promotion {
  id: string;
  idPromotionOrNew: number;
  itemCode: string;
  imageUrl: string;
  bannerHtml: string;
  typePosition: string;
  catalogGroup: string;
  url: string;
  type: TypePromotion;
  isLine: string;
  constructor() {
    this.idPromotionOrNew = NumberCons.zero;
    this.id = StringConst.empty;
    this.itemCode = StringConst.empty;
    this.imageUrl = StringConst.empty;
    this.bannerHtml = StringConst.empty;
    this.typePosition = StringConst.empty;
    this.url = StringConst.empty;
    this.type = TypePromotion.news;
    this.isLine = StringConst.empty;
    this.catalogGroup = StringConst.empty;
  }
}

export class DetailProduct {
  isFavorite: boolean;
  catalogGroup: string;
  costPerPieceDiscount: number;
  discountType: string;
  containerTaxRate: number;
  containerCost: number;
  containerCostDiscount: number;
  imgProduct: string;
  itemCodeHasMissing: boolean;
  containerHasMissing: boolean;
  itemCode: string;
  description: string;
  quantity: number;
  costPerPiece: number;
  label: string;
  container: string;
  startDate: Date;
  isLine: string;
  taxRate: number;
  displayPrices: DisplayPrices;
  displayUnique: string;
  arriveDateContainer: Date;
  arriveDateProduct: Date;
  missingPrinciplesActives: string[];
  hoffmanText: string | null;
  catalogGroupContainer?: string;
  containerItemCode?: string;
  additionalText: string;
  productFirmName: string;
  invalidLabels: string[];
  priceWithDiscount: number;
  constructor() {
    this.isFavorite = BooleanCons.false;
    this.catalogGroup = StringConst.empty;
    this.costPerPieceDiscount = NumberCons.zero;
    this.discountType = StringConst.empty;
    this.containerTaxRate = NumberCons.zero;
    this.containerCost = NumberCons.zero;
    this.containerCostDiscount = NumberCons.zero;
    this.imgProduct = StringConst.empty;
    this.itemCodeHasMissing = BooleanCons.false;
    this.containerHasMissing = BooleanCons.false;
    this.itemCode = StringConst.empty;
    this.description = StringConst.empty;
    this.quantity = NumberCons.zero;
    this.costPerPiece = NumberCons.zero;
    this.label = StringConst.empty;
    this.container = StringConst.empty;
    this.startDate = new Date();
    this.isLine = StringConst.empty;
    this.taxRate = NumberCons.zero;
    this.displayUnique = StringConst.empty;
    this.displayPrices = new DisplayPrices();
    this.arriveDateContainer = new Date();
    this.arriveDateProduct = new Date();
    this.missingPrinciplesActives = [];
    this.hoffmanText = '';
    this.catalogGroupContainer = StringConst.empty;
    this.containerItemCode = StringConst.empty;
    this.additionalText = StringConst.empty;
    this.productFirmName = StringConst.empty;
    this.invalidLabels = [];
    this.priceWithDiscount = NumberCons.zero;
  }
}

export class IProducts {
  itemCode: string;
  pedidoId: number;
  imgProduct: string;
  description: string;
  costPerPiece: number;
  isLine: string;
  taxRate: number;
  total: number;
  costPerPieceDiscount: number;
  discountPerPiece: number;
  cardCode: string;
  needRecipe: string;
  userId: string;
  cartType: number;
  checkPieces: boolean;
  isCalledTwoTimes: boolean;
  damagedPieces: number;
  hasDamagedPieces: boolean;
  utilityByPiece: number;
  utility: number;
  utilityPercentage: number;
  utilityByProduct: number;
  utilityAmount: number;
  priceToPublic: number;
  costThePublic: number;
  display: string;
  displayUnique: string;
  imageUrl: string;
  isContainsLabel: boolean;
  status: string;
  typeStatus: string;
  itemCodeHasMissing: boolean;
  arriveDateProduct: Date;
  isInvalidFromProduct: boolean;
  isPackage: boolean;
  productAttributes: ProductAttributes[];
  displayPrices: DisplayPrices;
  missingPrinciplesActives: string[];
  hoffmanText: string | null;
  catalogGroup: string;
  additionalText: string;
  productFirmName: string;
  invalidLabels: string[];
  priceWithDiscount: number;
  quantity: number;
  constructor() {
    this.isLine = StringConst.empty;
    this.arriveDateProduct = new Date();
    this.costPerPiece = NumberCons.zero;
    this.itemCode = StringConst.empty;
    this.description = StringConst.empty;
    this.description = StringConst.empty;
    this.needRecipe = StringConst.empty;
    this.checkPieces = BooleanCons.true;
    this.damagedPieces = NumberCons.zero;
    this.hasDamagedPieces = BooleanCons.false;
    this.utilityByPiece = NumberCons.zero;
    this.utilityPercentage = NumberCons.zero;
    this.utilityByProduct = NumberCons.zero;
    this.priceToPublic = NumberCons.zero;
    this.discountPerPiece = NumberCons.zero;
    this.display = StringConst.empty;
    this.displayUnique = StringConst.empty;
    this.pedidoId = NumberCons.zero;
    this.total = 0;
    this.taxRate = 0;
    this.imageUrl = StringConst.empty;
    this.isContainsLabel = BooleanCons.true;
    this.status = StringConst.empty;
    this.typeStatus = StringConst.empty;
    this.imgProduct = StringConst.empty;
    this.costPerPieceDiscount = NumberCons.zero;
    this.cardCode = StringConst.empty;
    this.userId = StringConst.empty;
    this.cartType = NumberCons.zero;
    this.isCalledTwoTimes = BooleanCons.false;
    this.utility = NumberCons.zero;
    this.utilityAmount = NumberCons.zero;
    this.costThePublic = NumberCons.zero;
    this.itemCodeHasMissing = BooleanCons.false;
    this.isInvalidFromProduct = false;
    this.isPackage = false;
    this.productAttributes = [];
    this.displayPrices = new DisplayPrices();
    this.missingPrinciplesActives = [];
    this.hoffmanText = '';
    this.catalogGroup = StringConst.empty;
    this.additionalText = StringConst.empty;
    this.productFirmName = StringConst.empty;
    this.invalidLabels = [];
    this.priceWithDiscount = NumberCons.zero;
    this.quantity = NumberCons.zero;
  }
}

export class DisplayPrices {
  costPerPiece: number;
  costPerPieceDiscount: number;
  taxRateCalculated: number;
  taxRateDiscountCalculated: number;
  totalWithoutDiscount: number;
  total: number;
  constructor() {
    this.costPerPiece = NumberCons.zero;
    this.costPerPieceDiscount = NumberCons.zero;
    this.taxRateCalculated = NumberCons.zero;
    this.taxRateDiscountCalculated = NumberCons.zero;
    this.total = NumberCons.zero;
    this.totalWithoutDiscount = NumberCons.zero;
  }
}

export class PricesPieces {
  costPerPiece: number;
  priceWithDiscount: number;
  constructor() {
    this.costPerPiece = NumberCons.zero;
    this.priceWithDiscount = NumberCons.zero;
  }
}
export class ProductAttributes {
  itemCode: string;
  description: string;
  label: string;
  container: string;
  quantity: number;
  isFavorite: boolean;
  containerCost: number;
  containerTaxRate: number;
  containerCostDiscount: number;
  containerHasMissing: boolean;
  arriveDateContainer: Date;
  containerError: boolean;
  labelError: boolean;
  originLabel: string;
  displayPrices: DisplayPrices;
  displayProductPrices: DisplayPrices;
  containerCatalogGroup: string;
  containerItemCode?: string;
  costPerPieceDiscount: number;
  costPerPiece: number;
  invalidLabels: string[];
  priceWithDiscount: number;
  invalidByLabel: boolean;
  discountType: string;
  validLabels: string[];
  constructor() {
    this.labelError = BooleanCons.false;
    this.label = StringConst.empty;
    this.container = StringConst.empty;
    this.quantity = NumberCons.zero;
    this.isFavorite = BooleanCons.false;
    this.containerCost = NumberCons.zero;
    this.containerTaxRate = NumberCons.zero;
    this.containerCostDiscount = NumberCons.zero;
    this.containerHasMissing = BooleanCons.false;
    this.arriveDateContainer = new Date();
    this.containerError = BooleanCons.false;
    this.originLabel = StringConst.empty;
    this.displayPrices = new DisplayPrices();
    this.containerCatalogGroup = StringConst.empty;
    this.containerItemCode = StringConst.empty;
    this.itemCode = StringConst.empty;
    this.description = StringConst.empty;
    this.costPerPieceDiscount = NumberCons.zero;
    this.costPerPiece = NumberCons.zero;
    this.invalidLabels = [];
    this.priceWithDiscount = NumberCons.zero;
    this.displayProductPrices = new DisplayPrices();
    this.invalidByLabel = BooleanCons.false;
    this.discountType = StringConst.empty;
    this.validLabels = [];
  }
}
export class PiecesChangeEmitter {
  productBeforeChange: IProducts;
  productAttributeId: number;
  constructor() {
    this.productBeforeChange = new IProducts();
    this.productAttributeId = NumberCons.zero;
  }
}
export class CallCardProduct {
  callPlace: CallPlace;
  detailProduct: IProducts;
  index?: number;
  constructor() {
    this.detailProduct = new IProducts();
    this.callPlace = CallPlace.default;
  }
}

export interface ReloadData {
  callPlace: CallPlace;
  index: number;
}

export class LoadShoppingCar {
  typeCar: TypeShoppingCar;
  constructor() {
    this.typeCar = TypeShoppingCar.default;
  }
}
export enum TypeShoppingCar {
  shoppingCar = 'shopping-car',
  saveShoppingCar = 'save-shopping-car',
  default = ''
}

export const TypeShoppingCarCompare = {
  shoppingCar: 'shopping-car',
  saveShoppingCar: 'save-shopping-car',
  default: ''
};
export class CallCardPromotion {
  detailPromotion: Promotion;
  index?: number;
  constructor() {
    this.detailPromotion = new Promotion();
  }
}

export const enum CallPlace {
  dialog,
  myProducts,
  myFavourites,
  listShoppingCart,
  detailOrderList,
  detailOrderListEdit,
  myProfile,
  detailOrderListDirection,
  detailOrderListTaxData,
  myOrders,
  deliveryAddresses,
  detailOrderListEditBack,
  orderResume,
  deliveryPayment,
  taxData,
  deliveryPaymentDelivery,
  deliveryPaymentTaxData,
  detailProducts,
  default,
  activeOrders,
  receiptSettings,
  deliveryData,
  taxDataPayment,
  paymentMethods,
  confirmOrder,
  deliveredOrders,
  components,
  dermazone,
  successPay,
  line,
  utilities,
  incidents,
  invoicesPending,
  invoicesPaid,
  averageTicket,
  pendingOrders,
  goals,
  myProfilePhotoAdvisor,
  myPendingProducts,
  favoritesAsesor,
  myProductsTopAsesor,
  pendingOrdersDialog,
  invoicesInProcess,
  invoicesInValidation,
  promotions,
  topProducts,
  activeOrdersAdviser,
  saveListShoppingCart,
  metricsPromotion,
  responsibleDoctors,
  responsibleDoctorInfo,
}

export const CallPlaceCompare = {
  dialog: 0,
  myProducts: 1,
  myFavourites: 2,
  listShoppingCart: 3,
  detailOrderList: 4,
  detailOrderListEdit: 5,
  myProfile: 6,
  detailOrderListDirection: 7,
  detailOrderListTaxData: 8,
  myOrders: 9,
  deliveryAddresses: 10,
  detailOrderListEditBack: 11,
  orderResume: 12,
  deliveryPayment: 13,
  taxData: 14,
  deliveryPaymentDelivery: 15,
  deliveryPaymentTaxData: 16,
  detailProducts: 17,
  default: 18,
  activeOrders: 19,
  receiptSettings: 20,
  deliveryData: 21,
  taxDataPayment: 22,
  paymentMethods: 23,
  confirmOrder: 24,
  deliveredOrders: 25,
  components: 26,
  dermazone: 27,
  successPay: 28,
  line: 29,
  utilities: 30,
  incidents: 31,
  invoicesPending: 32,
  invoicesPaid: 33,
  averageTicket: 34,
  pendingOrders: 35,
  goals: 36,
  myProfilePhotoAdvisor: 37,
  myPendingProducts: 38,
  favoritesAsesor: 39,
  myProductsTopAsesor: 40,
  pendingOrdersDialog: 41,
  invoicesInProcess: 42,
  invoicesInValidation: 43,
  promotions: 44,
  topProducts: 45,
  activeOrdersAdviser: 46,
  saveListShoppingCart: 47,
  metricsPromotion: 48,
  responsibleDoctors: 49
};
export class OpenDetailProduct {
  isFromMyProducts: boolean;
  detailProduct: IProducts;
  needContainerValidation: boolean;
  constructor() {
    this.isFromMyProducts = false;
    this.detailProduct = new IProducts();
    this.needContainerValidation = false;
  }
}
export class InfoFavourites {
  callPlace: CallPlace;
  index: number;

  constructor() {
    this.callPlace = CallPlace.default;
    this.index = 0;
  }
}
export class FavoriteConfig {
  isWebCalled: boolean;
  isCalledTwoTimes: boolean;
  constructor() {
    this.isCalledTwoTimes = false;
    this.isWebCalled = false;
  }
}

export class ChangeFavorite {
  indexAttribute: number;
  isFavorite: boolean;
  constructor() {
    this.indexAttribute = NumberCons.zero;
    this.isFavorite = BooleanCons.false;
  }
}

export const enum NotificationErrorType {
  label,
  container,
  labelQuantity,
  default,
}
export const NotificationErrorTypeCompare = {
  label: 0,
  container: 1,
  labelQuantity: 2,
  default: 3,
};

export const enum InvoiceTab {
  pending,
  inProcess,
  inValidation,
  default,
}

export const enum ShoppingTab {
  shoppingCart,
  savedShoppingCart,
}

export const ShoppingTabCompare = {
  shoppingCart: 0,
  savedShoppingCart: 1
};

export const RouteShoppingCarItem = {
  saved: 'saved',
  shopping: 'shopping'
};

export const InvoiceTabCompare = {
  pending: 0,
  inProcess: 1,
  inValidation: 2,
  default: 3,
};

export const enum TypeAutoCompletePrinciples {
  activePrinciple,
  rawMaterial,
  default,
}

export const TypeAutoCompletePrinciplesCompare = {
  activePrinciple: 0,
  rawMaterial: 1,
  default: 2,
};

export class RestoreCart {
  cardCode: string;
  typecart: string;
  priceListId: number;
  clientType: string;
  constructor() {
    this.cardCode = StringConst.empty;
    this.typecart = StringConst.empty;
    this.priceListId = NumberCons.zero;
    this.clientType = StringConst.empty;
  }
}

export interface ResponseRestoreCart extends BaseResponseHttp {
  response: ResponseAttributes[];
}

export class ResponseAttributes {
  itemCode: string;
  description: string;

  constructor() {
    this.itemCode = StringConst.empty;
    this.description = StringConst.empty;
  }
}

export class InactivityTime {
  days: number;
  hours: number;
  minutes: number;
  constructor() {
    this.days = NumberCons.zero;
    this.hours = NumberCons.zero;
    this.minutes = NumberCons.zero;
  }
}
export interface PromotionData {
  offset: number;
  limit: number;
  promotions: PromotionBanner[];
  totalTimesToCallTotal: number;
  totalTimesToCallCount: number;
  selectedIndex: number;
}

export class Policies {
  id: number;
  policyName: string;
  policyHtml: string;
  order: number;
  constructor() {
    this.id = NumberCons.zero;
    this.policyName = StringConst.empty;
    this.policyHtml = StringConst.empty;
    this.order = NumberCons.zero;
  }
}

export interface PoliciesResponse extends BaseResponseHttp {
  response: Policies[];
}
